import ServerSettings, {ServerSettingsFieldType} from "../../gd/settings/server-settings/server-settings";
import {
    LayoutFontSize,
    LayoutThemeUserSetting,
    UIType,
    MainMenuBackground,
    NavigationBackground
} from "../../../layout/ui/@const";


const fieldsConfig = {

    theme: {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : LayoutThemeUserSetting.LIGHT,
        options         : [LayoutThemeUserSetting.LIGHT, LayoutThemeUserSetting.DARK, LayoutThemeUserSetting.AUTO]
    },
    fontSize: {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : LayoutFontSize.DEFAULT,
        options         : [LayoutFontSize.DEFAULT, LayoutFontSize.SMALL]
    },

    lightPalette: {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : 'light-1',
        options         : ['light-1','light-2','light-3','light-4','light-5']
    },

    darkPalette: {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : 'dark-1',
        options         : ['dark-1']
    },

    layout: {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : UIType.LEFT,
        options         : [UIType.GOODDAY_MODERN, UIType.LEFT, UIType.TOP, UIType.ASANA, UIType.TEAMS, UIType.CLICK_UP]
    },

    // 'layout': {
    //     type            : 'option',
    //     defaultValue    : LayoutType.LEFT,
    //     options         : [LayoutType.LEFT,LayoutType.TOP, LayoutType.ASANA]
    // },


    menu: {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : MainMenuBackground.WHITE,
        options         : [
            MainMenuBackground.WHITE,
            MainMenuBackground.GRAY,
            MainMenuBackground.DARK,
            MainMenuBackground.PALE
        ]
    },

    navigation: {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : NavigationBackground.BLUE,
        options         : [
            NavigationBackground.BLUE,
            NavigationBackground.VIOLET,
            NavigationBackground.GREEN,
            NavigationBackground.TURQUOISE,
            NavigationBackground.DARK,
            NavigationBackground.GRAY
        ]
    },

    showNavbarLabels: {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : true
    },

}

export default class UserSettingsSkin extends ServerSettings {

    public theme            : LayoutThemeUserSetting
    public lightPalette     : any
    public darkPalette      : any
    public fontSize         : LayoutFontSize
    public layout           : UIType
    public menu             : MainMenuBackground
    public navigation       : NavigationBackground
    public showNavbarLabels : boolean

    constructor(config: any) {

        super(config, fieldsConfig);

        // reserved fo future - specifies which dark mode user has
        this.theme           = this.initValue('theme')

        // current contrast for light palette
        this.lightPalette       = this.initValue('lightPalette')

        // current contrast for dark palette
        this.darkPalette        = this.initValue('darkPalette')

        // font size
        this.fontSize           = this.initValue('fontSize')

        // layout
        this.layout             = this.initValue('layout')

        // menu bg color
        this.menu               = this.initValue('menu')

        // navigation panel color
        this.navigation         = this.initValue('navigation')

        this.showNavbarLabels   = this.initValue('showNavbarLabels')

        // in future accent color should be here... etc.

    }

    toJson() {

        const result = {};

        this.valueToJson(result, 'layout')
        this.valueToJson(result, 'theme')
        this.valueToJson(result, 'lightPalette')
        this.valueToJson(result, 'darkPalette')
        this.valueToJson(result, 'fontSize')
        this.valueToJson(result, 'menu')
        this.valueToJson(result, 'navigation')
        this.valueToJson(result, 'showNavbarLabels')

        return result;
    }
}
